<app-main-search [searchText]="searchTextFromQuery"></app-main-search>

